export interface IPaymentMethodDataRes {
  count: number;
  next: null;
  previous: null;
  numero_paginas: number;
  data: IPaymentMethod[];
}

export interface IPaymentMethod {
  id_formapago: string;
  nombre: string;
  codigo: string;
  alias?: string | null; // nombre_compuesto
  estado: boolean;
  tipo_contrato?: string;
  forma_pago: string;
  fecha_creacion?: string;
  fecha_modificacion?: string;
  numero_referencia: string;
  valor?: number;

  tarjeta: string;
  aplica_home: boolean
  aplica_pyme: boolean
  aplica_corporativo: boolean
  // fk
  entidad_financiera: string;
  codigo_sri?:string;
}


// // codigo_forma_pago
export enum PaymentMethodEnum {
  DEBITO = 'DÉBITO',
  TARJETA = 'TARJETA',
  RECAUDACION = 'RECAUDACIÓN', // CUANDO ES TRANSFERENCIA O EFECTIVO
}

export enum TipoContratoENUM {
  GEDATECU = 'GEDATECU',
  ELIANA_MOROCHO = 'ELIANA MOROCHO',
}
